import GoogleMapRoadmapPOIOnStyle from './GoogleMapRoadmapPOIOnStyle';
import GoogleMapRoadmapPOIOffStyle from './GoogleMapRoadmapPOIOffStyle';
import GoogleMapHybridPOIOffStyle from './GoogleMapHybridPOIOffStyle';
import GoogleMapHybridPOIOnStyle from './GoogleMapHybridPOIOnStyle';

export const MAP_STYLES = {
  ROADMAP_POI_ON: { styles: GoogleMapRoadmapPOIOnStyle, baseMapTypeId: 'roadmap' },
  ROADMAP_POI_OFF: { styles: GoogleMapRoadmapPOIOffStyle, baseMapTypeId: 'roadmap' },
  HYBRID_POI_ON: { styles: GoogleMapHybridPOIOnStyle, baseMapTypeId: 'hybrid' },
  HYBRID_POI_OFF: { styles: GoogleMapHybridPOIOffStyle, baseMapTypeId: 'hybrid' },
};

export function applyMapStyle( map, styleKey ) {
  const entry = MAP_STYLES[styleKey];
  if ( !entry ) return;
  map.setMapTypeId( entry.baseMapTypeId );
  map.setOptions( { styles: entry.styles } );
}
